import { createFileRoute } from "@tanstack/react-router";

import { ConnectionPage } from "~/pages/connection/connection.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/$connectionId",
)({
  component: ConnectionPage,
});
